import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store';

/****************************** FRONT PAGES ******************************/
import ServiceUnavailable from '@/views/ServiceUnavailable'

import Index    from '@/views/Index'

import Registration                             from '@/views/Registration/Registration.vue'
import Registrationforgot                       from '@/views/Registration/Forgot'
import RegistrationResetPassword                from '@/views/Registration/ResetPassword'
import RegistrationNotice                       from '@/views/Registration/Notice'
import RegistrationSelectPassport               from '@/views/Registration/SelectPassport'
import RegistrationTerms                        from '@/views/Registration/Terms'
import RegistrationPrivacy                      from '@/views/Registration/Privacy'
import RegistrationTokusho                      from '@/views/Registration/Tokusho'
import RegistrationWithEmail                    from '@/views/Registration/WithEmail'
import RegistrationEmailConfirmation            from '@/views/Registration/EmailConfirmation'
import RegistrationEmailConfirmationInfomation  from '@/views/Registration/EmailConfirmationInfomation'
import RegistrationLeave                        from '@/views/Registration/Leave'
import UserIdConfirmation                       from '@/views/Registration/UserIdConfirmation'

/****************************** APP PAGES ******************************/
import Home from '@/views/Home'

import Office from '@/views/Office'

import Connections          from '@/views/Connections/Connections'
import ConnectionsEntrance  from '@/views/Connections/Entrance'
import ConnectionRooms      from '@/views/Connections/Room'

import Parks            from '@/views/Parks/Parks'
import ParksEntrance    from '@/views/Parks/Entrance'
import ParksFinder      from '@/views/Parks/Finder'
import ParksDetail      from '@/views/Parks/Detail'
import ParksNoteDetail  from '@/views/Parks/NoteDetail';

Vue.use(VueRouter)

const routes = [
  {
    path      : '/unavailable',
    name      : 'serviceUnavailable',
    component : ServiceUnavailable
  },
  
  // #################### INDEX ####################  //
  {
    path      : '/',
    name      : 'index',
    component : Index
  },

  // #################### REGISTRATION ####################  //
  {
    path      : '/registration',
    component : Registration,
    children  : [
      {
        path          : '',
        beforeEnter   : (to, from, next) => {
          next({name: 'registration.notice'});
        }
      },

      {
        path          : 'notice',
        name          : 'registration.notice',
        component     : RegistrationNotice,
      },

      {
        path          : 'select-passport',
        name          : 'registration.selectPassport',
        component     : RegistrationSelectPassport,
      },

      {
        path          : 'with-email',
        name          : 'registration.withEmail',
        component     : RegistrationWithEmail,
      },

      {
        path          : 'confirmation-infomation/email/:id?',
        name          : 'registration.confirmationInfomation.email',
        component     : RegistrationEmailConfirmationInfomation,
      },

      {
        path          : '/email-confirmation/:token',
        name          : 'registration.emailConfirmation',
        component     : RegistrationEmailConfirmation,
      },

      {
        path          : '/user-id-confirmation',
        name          : 'registration.userIdConfirmation',
        component     : UserIdConfirmation,
      },

      {
        path      : '/forgot',
        name      : 'forgot',
        component : Registrationforgot
      },

      {
        path      : '/reset-password/:token/:email',
        name      : 'resetPassword',
        component : RegistrationResetPassword,
      },

      {
        path      : '/leave',
        name      : 'leave',
        component : RegistrationLeave,
      },

      {
        path      : '/terms',
        name      : 'terms',
        component : RegistrationTerms
      },

      {
        path      : '/privacy',
        name      : 'privacy',
        component : RegistrationPrivacy
      },

      {
        path      : '/japanese-commerce-transaction-label',
        name      : 'tokusho',
        component : RegistrationTokusho
      },
    ]
  },

  // #################### HOME ####################  //
  {
    path        : '/home',
    name        : 'home',
    component   : Home,
    beforeEnter : async (to, from, next) => {
      await store.dispatch({
        type      : 'updateRoutingPosition',
        position  : 'home',
      });

      next();
    }
  },

  // #################### CONNECTIONS ####################  //
  {
    path      : '/connections',
    component : Connections,
    beforeEnter : async (to, from, next) => {
      await store.dispatch({
        type      : 'updateRoutingPosition',
        position  : 'connection',
      });

      next();
    },
    children  : [
      {
        path          : '',
        name          : 'connections',
        beforeEnter   : (to, from, next) => {
          next({name: 'connections.entrance'});
        }
      },
      {
        path: 'entrance',
        name: 'connections.entrance',
        component: ConnectionsEntrance,
      },
      {
        path: 'rooms/:roomType?',
        name: 'connections.room',
        component: ConnectionRooms,
        props: (route) => ({ roomType: route.params.roomType || 'public' })
      },
    ]
  },

  // #################### PARKS ####################  //

  {
    path      : '/parks',
    component : Parks,
    beforeEnter : async (to, from, next) => {
      await store.dispatch({
        type      : 'updateRoutingPosition',
        position  : 'park',
      });

      next();
    },
    children  : [
      {
        path          : '',
        name          : 'parks',
        beforeEnter   : (to, from, next) => {
          next({name: 'parks.entrance'});
        }
      },
      {
        path: 'entrance',
        name: 'parks.entrance',
        component: ParksEntrance,
      },
      {
        path: 'view/:viewType?',
        name: 'parks.view',
        component: ParksFinder,
        props : (route) => {
          if(typeof route.params.viewType === 'undefined'){
            route.params.viewType = 'finder';
          }
        }
      },
      {
        path: ':parkId/detail',
        name: 'parks.detail',
        component: ParksDetail,
      },
      {
        path: ':parkId/note/:noteId',
        name: 'parks.note.detail',
        component: ParksNoteDetail,
      },
    ]
  },


  // #################### OFFICE ####################  //
  {
    path        : '/office',
    name        : 'office',
    component   : Office,
    beforeEnter : async (to, from, next) => {
      await store.dispatch({
        type      : 'updateRoutingPosition',
        position  : 'office',
      });

      next();
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if(typeof to.query.y !== 'undefined'){
        return { x: 0, y: to.query.y }
      }else{
        return { x: 0, y: 0 }
      }
      
    }
  }
})

export default router
